import _keccakStateUnroll from "./keccak-state-unroll";
import _buffer from "buffer";
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
var Buffer = _buffer.Buffer;
const keccakState = _keccakStateUnroll;
function Keccak() {
  // much faster than `new Array(50)`
  (this || _global).state = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  (this || _global).blockSize = null;
  (this || _global).count = 0;
  (this || _global).squeezing = false;
}
Keccak.prototype.initialize = function (rate, capacity) {
  for (let i = 0; i < 50; ++i) (this || _global).state[i] = 0;
  (this || _global).blockSize = rate / 8;
  (this || _global).count = 0;
  (this || _global).squeezing = false;
};
Keccak.prototype.absorb = function (data) {
  for (let i = 0; i < data.length; ++i) {
    (this || _global).state[~~((this || _global).count / 4)] ^= data[i] << 8 * ((this || _global).count % 4);
    (this || _global).count += 1;
    if ((this || _global).count === (this || _global).blockSize) {
      keccakState.p1600((this || _global).state);
      (this || _global).count = 0;
    }
  }
};
Keccak.prototype.absorbLastFewBits = function (bits) {
  (this || _global).state[~~((this || _global).count / 4)] ^= bits << 8 * ((this || _global).count % 4);
  if ((bits & 128) !== 0 && (this || _global).count === (this || _global).blockSize - 1) keccakState.p1600((this || _global).state);
  (this || _global).state[~~(((this || _global).blockSize - 1) / 4)] ^= 128 << 8 * (((this || _global).blockSize - 1) % 4);
  keccakState.p1600((this || _global).state);
  (this || _global).count = 0;
  (this || _global).squeezing = true;
};
Keccak.prototype.squeeze = function (length) {
  if (!(this || _global).squeezing) this.absorbLastFewBits(1);
  const output = Buffer.alloc(length);
  for (let i = 0; i < length; ++i) {
    output[i] = (this || _global).state[~~((this || _global).count / 4)] >>> 8 * ((this || _global).count % 4) & 255;
    (this || _global).count += 1;
    if ((this || _global).count === (this || _global).blockSize) {
      keccakState.p1600((this || _global).state);
      (this || _global).count = 0;
    }
  }
  return output;
};
Keccak.prototype.copy = function (dest) {
  for (let i = 0; i < 50; ++i) dest.state[i] = (this || _global).state[i];
  dest.blockSize = (this || _global).blockSize;
  dest.count = (this || _global).count;
  dest.squeezing = (this || _global).squeezing;
};
exports = Keccak;
export default exports;